module.exports = __webpack_public_path__ + "assets/img/3.cd39df36.png";